(function() { 
    const selectors = { 
        productOptionInput: ".product-form__swatch__input", 
        productSectionParent: ".product-section__container", 
        productMedia: ".media-gallery", 
        productGalleryThumbContainer: ".js-product-slider-nav", 
        productGalleryThumbnails: ".js-product-slider-nav-thumbs", 
        scrollerUp: ".product-gallery__custom-scroller--up", 
        scrollerDown: ".product-gallery__custom-scroller--down", 
        thumbnail: ".thumbnail"
    }

    const classes = { 
        hide: "force-hide"
    }

    const scrollDuration = 700; 

    /**
     * Utility Functions
     */

    const enableDesktopThumbScrolls = (productSection) => { 
        const productGalleryThumbnails = productSection.querySelector(selectors.productGalleryThumbContainer); 
        const productGalleryThumbnailWrapper = productSection.querySelector(selectors.productGalleryThumbnails); 

        if (productSection.querySelector(selectors.scrollerUp) && 
            productGalleryThumbnails.scrollTop > 0) { 
            productSection.querySelector(selectors.scrollerUp).classList.remove(classes.hide); 
        } else { 
            productSection.querySelector(selectors.scrollerUp).classList.add(classes.hide);    
        }

        if (productSection.querySelector(selectors.scrollerDown) && 
            (Math.ceil(productGalleryThumbnails.scrollTop) + productGalleryThumbnails.offsetHeight) < (productGalleryThumbnailWrapper.offsetHeight - 48)) { 
            productSection.querySelector(selectors.scrollerDown).classList.remove(classes.hide); 
        } else { 
            productSection.querySelector(selectors.scrollerDown).classList.add(classes.hide); 
        }
    }

    const disableDesktopThumbScrolls = (productSection) => { 
        if (productSection.querySelector(selectors.scrollerUp)) productSection.querySelector(selectors.scrollerUp).classList.add(classes.hide); 
        if (productSection.querySelector(selectors.scrollerDown)) productSection.querySelector(selectors.scrollerDown).classList.add(classes.hide); 
    }

    const checkForScrollEligibility = (productSection) => { 
        const productMedia = productSection.querySelector(selectors.productMedia); 
        const productGalleryThumbnails = productSection.querySelector(selectors.productGalleryThumbnails); 
        
        if (window.innerWidth > 980 && 
            (productGalleryThumbnails.offsetHeight - 48) > productMedia.offsetHeight) { 
            enableDesktopThumbScrolls(productSection); 
        } else { 
            disableDesktopThumbScrolls(productSection); 
        }
    }

    const scrollThumbsUp = (productSection) => { 
        if (productSection.querySelector(selectors.productGalleryThumbContainer)) { 
            const scrollContainer = productSection.querySelector(selectors.productGalleryThumbContainer); 
            const thumbHeight = scrollContainer.querySelector(selectors.thumbnail).offsetHeight; 

            scrollContainer.scrollTo({ 
                top: scrollContainer.scrollTo - thumbHeight, 
                left: 0, 
                behavior: "smooth"
            }); 

            setTimeout(function() { 
                enableDesktopThumbScrolls(productSection); 
            }, scrollDuration)
        }
    }

    const scrollThumbsDown = (productSection) => { 
        if (productSection.querySelector(selectors.productGalleryThumbContainer)) { 
            const scrollContainer = productSection.querySelector(selectors.productGalleryThumbContainer); 
            const thumbHeight = scrollContainer.querySelector(selectors.thumbnail).offsetHeight; 

            scrollContainer.scrollTo({ 
                top: scrollContainer.offsetHeight + thumbHeight, 
                left: 0, 
                behavior: "smooth"
            }); 

            setTimeout(function() { 
                enableDesktopThumbScrolls(productSection); 
            }, scrollDuration)
        }
    }

    /**
     * Event Handlers
     */
    
    const handleChange = (e) => { 
        const target = e.target; 
        if (!target.closest(selectors.productOptionInput)) return; 

        const productSection = target.closest(selectors.productSectionParent); 

        if (!productSection) return; 

        const productGalleryThumbnails = productSection.querySelector(selectors.productGalleryThumbContainer); 

        if (productGalleryThumbnails) productGalleryThumbnails.scrollTo(0,0); 

        checkForScrollEligibility(productSection); 
    }

    const handleClick = (e) => { 
        const target = e.target; 

        const productSection = target.closest(selectors.productSectionParent); 

        if (!productSection) return; 

        // if (!target.closest(selectors.scrollerUp) && !target.closest(selectors.scrollerUp)) return; 

        if (target.closest(selectors.scrollerUp)) { 
            scrollThumbsUp(productSection); 

        } else if (target.closest(selectors.scrollerDown)) { 
            scrollThumbsDown(productSection); 
        }
    }

    /**
     * Event Listeners
     */

    document.addEventListener("change", handleChange); 
    document.addEventListener("click", handleClick); 

    /**
     * Initialization
     */

    window.addEventListener("load", function() { 
        if (document.querySelector(selectors.productSectionParent)) { 
            checkForScrollEligibility(document.querySelector(selectors.productSectionParent)); 
        }
    }); 
})(); 